import React, { useState, useEffect } from "react";
import exelIcon from "../../../../../assets/ms_excel.png";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'
import * as XLSX from "xlsx";
import "./ConferenceLogs.css";

export default function ConferenceLogs() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [filter, setFilter] = useState("all");

  const {
    initialReservation
  } = useSelector((state) => state.RoomMenu);

  const userName = (data) => {
    if (!data?.user) return t("UNDEFINED_USER");

    if (data.role === "guest_externe" && data.user.display_name === "Guest") {
      return data.email;
    }

    return data.user.display_name;
  };

  const formatLogs = (data = []) => {
    return [...data]
      .sort((a, b) => new Date(b.date) - new Date(a.date)) // 🔥 TRI DESC
      .map(item => {
        const dateObj = new Date(item.date);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear();
        const hours = String(dateObj.getHours()).padStart(2, "0");
        const minutes = String(dateObj.getMinutes()).padStart(2, "0");

        return {
          date: `${day}/${month}/${year}`,
          time: `${hours}:${minutes}`,
          type: item.type,
          user: userName(item),
          label: `${item.description}`
        };
      });
  };

  const logsData = formatLogs(initialReservation?.conferenceAction || []);

  const groupByDate = (data) => {
    return data.reduce((acc, item) => {
      if (!acc[item.date]) {
        acc[item.date] = [];
      }
      acc[item.date].push(item);
      return acc;
    }, {});
  };

  const filteredLogs = !filter || filter === "all" ? logsData : logsData.filter(log => log.type === filter);

  const groupedLogs = groupByDate(filteredLogs);

  const formatDateLabel = (dateStr) => {
    const [d, m, y] = dateStr.split("/");
    const date = new Date(`${y}-${m}-${d}`);

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return t('today');
    if (date.toDateString() === yesterday.toDateString()) return t('yesterday');

    return dateStr;
  };

  const iconClass = type => {
    switch (type) {
      case "bans":
        return "block";
      case "attendance":
        return "visibility";
      case "emails":
        return "mail";
      case "registration":
        return "edit_document";
      case "system":
        return "settings";
      default:
        return "";
    }
  };

  const [activeDates, setActiveDates] = useState([]);
  const handleToggleDate = (date) => {
    setActiveDates(prev => {
      if (prev.includes(date)) {
        // retirer
        return prev.filter(d => d !== date);
      } else {
        // ajouter
        return [...prev, date];
      }
    });
  };
  useEffect(() => {
    const dates = Object.keys(groupedLogs);

    if (dates.length > 0) {
      setActiveDates([dates[0]]); // 👈 première date active
    }
  }, []);

  const handleFilter = (e, value = null) => {
    e.preventDefault();
    setFilter(value)
  }


  const handleExportExcel = (e) => {
    e.preventDefault();
    if (!filteredLogs.length) return;
    const dataToExport = filteredLogs.map(log => ({
      Date: log.date,
      Heure: log.time,
      Type: log.type,
      Description: t(log.label, { name: log.user }) // ✅ CORRECT
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");
    XLSX.writeFile(workbook, "conference_logs.xlsx");
  };


  return (
    <div className="logs-container">

      <div className="logs-header">
        <h3>
          <span className="logs-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5002 10H8.3335" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12.5002 6.66699H8.3335" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M15.8335 14.1667V4.16667C15.8335 3.72464 15.6579 3.30072 15.3453 2.98816C15.0328 2.67559 14.6089 2.5 14.1668 2.5H3.3335" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.6665 17.5H16.6665C17.1085 17.5 17.5325 17.3244 17.845 17.0118C18.1576 16.6993 18.3332 16.2754 18.3332 15.8333V15C18.3332 14.779 18.2454 14.567 18.0891 14.4107C17.9328 14.2545 17.7209 14.1667 17.4998 14.1667H9.1665C8.94549 14.1667 8.73353 14.2545 8.57725 14.4107C8.42097 14.567 8.33317 14.779 8.33317 15V15.8333C8.33317 16.2754 8.15758 16.6993 7.84501 17.0118C7.53245 17.3244 7.10853 17.5 6.6665 17.5ZM6.6665 17.5C6.22448 17.5 5.80055 17.3244 5.48799 17.0118C5.17543 16.6993 4.99984 16.2754 4.99984 15.8333V4.16667C4.99984 3.72464 4.82424 3.30072 4.51168 2.98816C4.19912 2.67559 3.7752 2.5 3.33317 2.5C2.89114 2.5 2.46722 2.67559 2.15466 2.98816C1.8421 3.30072 1.6665 3.72464 1.6665 4.16667V5.83333C1.6665 6.05435 1.7543 6.26631 1.91058 6.42259C2.06686 6.57887 2.27882 6.66667 2.49984 6.66667H4.99984" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {t('logs')}
          </span>
          <span className="actions-count">{logsData.length} Action{logsData.length > 1 && 's'}</span>
        </h3>
        <button className="btn export-xlsx" onClick={handleExportExcel}><img src={exelIcon} />{t('export_excel')}</button>
      </div>

      <div className="logs-filters">
        {["all", "registration", "emails", "attendance", "system", "bans"].map(f => (
          <button
            key={f}
            className={`filter ${filter === f ? "active" : ""}`}
            onClick={(e) => handleFilter(e, f)}
          >
            {
              f !== 'all' &&
              <span className={`action-dot dot-${f}`}></span>
            }
            {t(f)}
          </button>
        ))}
      </div>

      <input
        className="logs-search"
        placeholder={t('search_an_action')+'...'}
      />

      {Object.entries(groupedLogs)
        .sort((a, b) => {
          const [d1, m1, y1] = a[0].split("/");
          const [d2, m2, y2] = b[0].split("/");

          return new Date(`${y2}-${m2}-${d2}`) - new Date(`${y1}-${m1}-${d1}`);
        })
        .map(([date, logs]) => (
          <div key={date} className={`log-group ${activeDates.includes(date) ? "active" : ""}`}>

            <h3 className="log-date">
              <span className="date-info">
                {formatDateLabel(date)}
                <span className="actions-count">{logs.length} {logs.length > 1 ? t('actions') : t('action')}</span>
              </span>
              <span class="material-symbols-outlined" onClick={() => handleToggleDate(date)}>
                keyboard_arrow_down
              </span>
            </h3>

            <div className="logs-list">
              {logs.map((log, i) => (
                <div key={i} className="log-item">

                  <div className="log-time">{log.time}</div>

                  <div className="log-content">
                    <span className={`log-icon type-icon-${log.type} material-symbols-outlined`}>
                      {iconClass(log.type)}
                    </span>
                    <div className="log-text">
                      <span className="d-block">
                        {t(log.label, { name: log.user })}
                      </span>

                      <span className={`badge ${log.type}`}>
                        {t(log.type)}
                      </span>
                    </div>
                  </div>

                </div>
              ))}
            </div>

          </div>
        ))}
    </div>
  );
}